const simulateClick = (url1, url2 = null) => {
    const firstWindow = window.open(url1, '_blank');
    if (firstWindow.document.readyState === 'complete' && url2) {
        window.open(url2, '_blank');

        setTimeout(() => firstWindow.close(), 2000);
    }
};

export default simulateClick;
